import React, { Component } from 'react'
import FacebookIcon from '@material-ui/icons/Facebook';
import GitHubIcon from '@material-ui/icons/GitHub';
import InstagramIcon from '@material-ui/icons/Instagram';
import MailIcon from '@material-ui/icons/Mail';
import RoomIcon from '@material-ui/icons/Room';
import PhoneIcon from '@material-ui/icons/Phone';
import AlternateEmailIcon from '@material-ui/icons/AlternateEmail';
import LinkedInIcon from '@material-ui/icons/LinkedIn';


export default class Footer extends Component {
    constructor(props) {
        super(props)

        this.state = {
             name:'',
             email:'',
             message:'',

        }
    }
    handleNameChange= (event) => {
        this.setState({
            name:event.target.value,
        })
    }
    handleEmailChange= (event) => {
        this.setState({
            email:event.target.value,
        })
    }
    handleMessageChange= (event) => {
        this.setState({
            message:event.target.value,
        })
    }
    HandleSubmit=(event)=>{
        if(this.state.name && this.state.email && this.state.message!== null){
        alert(`
                Name: ${ this.state.name} 
                Email id: ${ this.state.email}  
                Message: ${ this.state.message}
                 
                Thank you, We will connect soon! `)
        }
        else{
            alert(`I think you missed a section in the form please check. `)
        }
        
        event.preventDefault()
    }
    

    render() {
        {/*const{name, email , message}=this.state*/}
        return (
            <footer id="contact-page" className="footer-class">
                <a href ='/' className="footer-brand">nitin kumar</a>
                    <div className="footer-main">
                        <div className="left-box">
                            <h2>About</h2>
                                <div className="left-content">
                                <p className="left-content-para">
                                I am a tireless seeker of knowledge, occassional purveyor
                                 of wisdom and also, coincidentally, a human.                        
                                </p>

                                <div className="footer-social-icons">
                                    <a className="footer-button-icon" href='https://www.facebook.com/profile.php?id=100002043198152' target="_blank"><FacebookIcon/></a>
                                    <a className="footer-button-icon" href='https://github.com/NitinKumar16' target="_blank"><GitHubIcon/></a>
                                    <a className="footer-button-icon" href='https://www.instagram.com/palindrome_97/' target="_blank"><InstagramIcon/></a>
                                    <a className="footer-button-icon" href='mailto:nitin16kumar97@gmail.com' target="_blank"><MailIcon/></a>
                                    <a className="footer-button-icon" href='https://www.linkedin.com/in/nitin-kumar-b421a9190/' target="_blank"><LinkedInIcon/></a>

                                </div>
                            </div>
                        </div>
                        <div class="center-box">
                            <h2>Address</h2>                        
                            <div className="content">
                                <div className="place">
                                    <span className="center-icons"><RoomIcon/></span>
                                    <span className="text">Mumbai, Colaba</span>
                                </div>

                                <div className="phone">
                                    <span className="center-icons"><PhoneIcon/></span>
                                    <span className="text">98699370654</span>
                                </div>

                                <div className="email">
                                    <span className="center-icons"><AlternateEmailIcon/></span>
                                    <span className="text">nitin16kumar97@gmail.com</span>
                                </div>

                                <div className="email">
                                    <span className="center-icons"><AlternateEmailIcon/></span>
                                    <span className="text">nitin_16kumar@outlook.com</span>
                                </div>
                            </div>
                        </div>

{/*============================== FORM TO CONNECT WITH EMAIL =================================*/}

                        <form className="feedback-container">
                            <h2>Lets talk! <br/>Contact form coming soon</h2>

                            <div className='inputBox'>
                                <input type='text' value={this.state.name} 
                                    onChange={this.handleNameChange} required='required'/>
                                <span>Full Name</span>
                            </div>

                            <div className='inputBox'>
                                <input type='email' value={this.state.email} onChange={this.handleEmailChange} required='required'/>
                                <span>Email Address</span>
                            </div>

                            <div className='inputBox'>
                                <textarea value={this.state.message} onChange={this.handleMessageChange} required='required'></textarea>
                                <span>Type your message here...</span>
                            </div>

                            <div className='inputBox'>
                                <input type='submit' onClick={this.HandleSubmit} 
                                Value='Send' name=''/>
                            </div>
                        </form>
                    </div>

            </footer>
        )
    }
}
